export default __webpack_public_path__ + "static/media/YODA.f8032ee9.webp";